<template>
  <div id="footer">
    <footer>
      <div class="rnFooterWrap">
        <div class="rnFooter">
          <h3>고객센터</h3>
          <a href="tel:1522-8586" class="footTel">
            1522-8586
            <svg width="18" height="18" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.012 12.952a.884.884 0 0 0-.04 1.1l.073.084.059.06a.78.78 0 0 0 1.057-.004l.062-.065 4.765-5.516a.863.863 0 0 0 .21-.601v-.097a.876.876 0 0 0-.21-.524L6.223 1.873A.78.78 0 0 0 5.1 1.81l-.055.055a.883.883 0 0 0-.033 1.184L9.29 8z" fill="#333" fill-rule="evenodd" opacity="1"></path>
            </svg>
          </a>
          <p class="footTime">
            <span>평일 09:00 - 18:00 운영 / 점심시간 12:00 - 13:30</span>
            <span>주말 및 공휴일은 채팅상담으로 문의를 남겨주시면 상담 가능 시간에 순차적으로 상담 도와드리겠습니다.</span>
          </p>

          <div class="companyInfoWrap">
            <p class="companyInfoTitle" v-on:click="toggle">
                (주)차일디
                <span>
                  <svg id="btnSvg" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.667 4.386a.773.773 0 0 0-.962-.035l-.074.063-.052.052a.682.682 0 0 0 .003.924l.057.055 4.826 4.17c.15.13.345.194.526.184h.085a.766.766 0 0 0 .458-.185l4.827-4.169a.682.682 0 0 0 .056-.983l-.048-.048a.772.772 0 0 0-1.036-.028L7 8.128z" fill="#979797" fill-rule="evenodd"></path>
                  </svg>
                </span>
              </p>
              <vue-slide-up-down :active="active">
                <div class="companyInfoBox">
                  <dl>
                    <dt>대표</dt>
                    <dd>강준기</dd>
                  </dl>
                  <dl>
                    <dt>주소</dt>
                    <dd>경기도 고양시 일산동구 무궁화로 18 (남정 씨티프라자 1) 603-06호(장항동)</dd>
                  </dl>
                  <dl>
                    <dt>사업자번호</dt>
                    <dd>833-81-01903 <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8338101903&amp;apv_perm_no=" class="businessLicenseNumber">사업자번호조회</a></dd>
                  </dl>
                  <dl>
                    <dt>개인정보 관리자</dt>
                    <dd>이경구</dd>
                  </dl>
                  <dl>
                    <dt>통신판매업신고번호</dt>
                    <dd>제2022-고양일산동-2436호</dd>
                  </dl>
                  <dl>
                    <dt>마케팅 제휴문의</dt>
                    <dd>
                      <a href="mailto:marketing@childy.co.kr">marketing@childy.co.kr</a>
                    </dd>
                  </dl>
                  <dl>
                    <dd>
                      ⓒ childy.co.kr. All rights reserved
                      <!-- <a href="https://m.childy.co.kr/event/thank_you_event">.</a>
                      <a href="https://m.childy.co.kr/childeal/?dealNo=3">.</a> -->
                    </dd>
                  </dl>
                </div>
              </vue-slide-up-down>
          </div>

          <div class="footMenuWrap">
            <ul class="footMenu">
              <li><a href="https://m.childy.co.kr/service/agreement.php">이용약관</a></li>
              <li><a href="https://m.childy.co.kr/service/private.php" class="privacy">개인정보처리방침</a></li>
              <li><a href="https://m.childy.co.kr/service/guide.php">이용안내</a></li>
              <li><a href="https://m.childy.co.kr/main/html.php?htmid=proc/info_guide.html" target="_blank">교환/반품 방법</a></li>
              <li><a href="https://forms.gle/A7gN7tJzuCEuRMxv9" target="_blank">입점/제휴 문의</a></li>
              <li><a href="https://m.childy.co.kr/service/faq_list.php">자주하는 질문</a></li>
              <li><a href="https://m.childy.co.kr/board/list.php?bdId=notice">공지사항</a></li>
            </ul>
          </div>

        </div>
      </div>



    </footer>

    <div class="goTopScroll" v-show="isTop" @click="goToTop">
      <span>TOP</span>
    </div>

    <div class="fixed_footer" :class="{ 'hidden-navbar': !showNavbar }">
      <ul>
        <li><a href="https://m.childy.co.kr/main/index.php" class="btn_bottom_home"><span>홈</span></a></li>
        <li><a href="#" v-on:click.prevent="nonClick" class="side_menu"><span class="side_bottom_menu">카테고리</span></a></li>
        <li><a href="https://m.childy.co.kr/mypage/wish_list.php" class="wish"><span class="btn_bottom_wish">좋아요</span></a></li>
        <li><a href="https://m.childy.co.kr/mypage/recent_list"><span class="btn_bottom_recent">최근 본 상품</span></a></li>
        <li><a href="https://m.childy.co.kr/mypage/index.php" class="mypage"><span class="btn_bottom_mypage">마이페이지</span></a></li>
      </ul>
    </div>

    <Navi></Navi>

  </div>
</template>


<script>
import VueSlideUpDown from 'vue-slide-up-down'
import Navi from '@/components/navi/navi.vue'

const OFFSET = 60
export default{ 
  components:{
    'vue-slide-up-down': VueSlideUpDown,
    Navi,
  },
  data(){
    return{
      isTop: false,
      sampleData:'',
      active: false,
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0,
    };
  },
  setup(){},
  created(){},
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  unmounted(){},
  methods:{
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition == 0) {
        this.isTop = false; //TOP일때 비노출
      } else {
        this.isTop = true; //TOP일때 노출
      }

      if (currentScrollPosition < 0) {
        return
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    // goToTop() {
    //  vue3 로 작업시 (스크롤 효과 속도 제어 불가능.)
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth' // 부드러운 스크롤 효과를 적용합니다.
    //   })
    // },
    goToTop() {
      const scrollDuration = 500; // 애니메이션의 지속 시간 (밀리초 단위)
      const scrollStep = -window.scrollY / (scrollDuration / 15); // 스크롤 간격 (15ms마다)
      const scrollInterval = setInterval(function() {
        if (window.scrollY !== 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval);
        }
      }, 0);
    },

    nonClick() {
      //클릭 동작 액션X
    },


    toggle() {
      this.active = !this.active;
      const btnSvg = document.getElementById('btnSvg');
      if(this.active){
        btnSvg.classList.add('rote');
      }else{
        btnSvg.classList.remove('rote');
      }
    }
  }
}
</script>
<style>
.hidden-navbar{
  transition: 0.5s;
  bottom:-100%;
}
</style>
